import { render, staticRenderFns } from "./Form213_v2.vue?vue&type=template&id=3d1f6c20&scoped=true&"
import script from "./Form213_v2.vue?vue&type=script&lang=js&"
export * from "./Form213_v2.vue?vue&type=script&lang=js&"
import style0 from "./Form213_v2.vue?vue&type=style&index=0&id=3d1f6c20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d1f6c20",
  null
  
)

export default component.exports